import {
  CategoryScale,
  Chart as ChartJS,
  Legend,
  LineElement,
  LinearScale,
  PointElement,
  Title,
  Tooltip,
} from "chart.js";
import React, { useMemo } from "react";
import { Line } from "react-chartjs-2";

import MDBox from "@/components/atoms/MDBox";

import configs from "./configs";

ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend);

type Dataset = {
  tension?: number;
  pointRadius?: number;
  borderWidth?: number;
  backgroundColor?: string;
  fill?: boolean;
  pointBackgroundColor?: string;
  borderColor?: string;
  maxBarThickness?: number;
  color?: string;
};

type ChartProps = {
  labels?: string[];
  datasets?: Dataset[];
};

type DefaultLineChartProps = {
  height?: string | number;
  chart: ChartProps;
  currency?: boolean;
};

const DefaultLineChart: React.FC<DefaultLineChartProps> = ({
  height = "19.125rem",
  chart,
  currency = false,
}) => {
  const chartDatasets = chart.datasets
    ? chart.datasets.map((dataset) => ({
        ...dataset,
        tension: 0,
        pointRadius: 3,
        borderWidth: 4,
        fill: false,
        pointBackgroundColor: dataset.backgroundColor,
        borderColor: dataset.backgroundColor,
        maxBarThickness: 6,
      }))
    : [];

  const { data, options } = configs(chart.labels || [], chartDatasets);

  options.scales = {
    y: {
      ticks: {
        callback: function (tickValue: string | number) {
          const value = typeof tickValue === "string" ? parseFloat(tickValue) : tickValue;
          return currency
            ? `R$ ${value.toLocaleString("pt-BR", { minimumFractionDigits: 0 })}`
            : Math.trunc(value);
        },
      },
    },
  };

  const renderChart = (
    <MDBox py={2} pr={2} pl={2}>
      {useMemo(
        () => (
          <MDBox height={height}>
            <Line data={data} options={options} />
          </MDBox>
        ),
        /* eslint-disable react-hooks/exhaustive-deps */
        [chart, height]
      )}
    </MDBox>
  );

  return renderChart;
};

export default DefaultLineChart;
